import React from 'react';
import DataTableGrid from '../../../components/common/DataTableGrid';
import '../WellDiagnosis.scss';

interface DiagnosisTableWidgetProps {
  widgetHeader: string;
  columnData: any[];
  tableData: any[];
  enableBorder?: boolean;
  alignCenter?: boolean;
}

const DiagnosisTableWidget: React.FC<DiagnosisTableWidgetProps> = ({
  widgetHeader,
  columnData,
  tableData,
  enableBorder,
  alignCenter = false,
}) => {
  const columnsNoFilter = columnData.map((col) => ({ ...col, disableFilters: true }));
  return (
    <div className='diagnosis-main-container diagnosis-table-widget'>
      <header className='cust-table-header'>
        <div className='cust-table-header-wrap diagnosis-table-header-wrap'>
          <h1 className='table-header-title'>{widgetHeader}</h1>
        </div>
      </header>
      <div className='diagnosis-table-content' style={{ padding: '12px 0px' }}>
        <DataTableGrid
          data={tableData}
          columns={columnsNoFilter}
          maxHeight='100%'
          enableBorder={enableBorder}
          alignCenter={alignCenter}
          noRecordsHeight='431px'
        />
      </div>
    </div>
  );
};

export default DiagnosisTableWidget;
